import {
  AfterViewInit,
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { Router } from "@angular/router";
import { AppFlowService } from "../../services/app-flow.service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { SessionStorageService } from "../../services/session-storage.service";
import {
  BuscarLojasPorProximidadeConfig,
  EnvConfig,
} from "../../models/env-config";
import { UntypedFormBuilder, UntypedFormControl, FormGroup } from "@angular/forms";
import { Campo, Tipo, Opcoe } from "src/app/models/coleta";
import { CanalService } from "src/app/services/canal.service";
import { NgSelectComponent } from "@ng-select/ng-select";
import { Subscription } from "rxjs";
import { GeolocationService } from "src/app/services/geolocation.service";
import { MatDialog } from "@angular/material/dialog";
import { DialogComponent } from "src/app/components/dialog/dialog.component";
import browserUtils from "src/app/utils/browser.utils";
import { DialogHtmlComponent } from "src/app/components/dialog-html/dialog-html.component";
import { STORAGE_KEYS } from "src/app/components/dynamic-inputs/util/constants";
import { Canal, PoliticaResponse } from "src/app/models/canal";

@Component({
  selector: "app-landing-page",
  templateUrl: "./landing-page.component.html",
  styleUrls: ["./landing-page.component.scss"],
})
export class LandingPageComponent implements OnInit, AfterViewInit, OnDestroy {
  messageTitle: string;
  origemComercialId: string = "";
  internalCampo: Campo = {};
  name = "";
  options: any;

  @ViewChild("ngSelect") ngSelect!: NgSelectComponent;

  currentFormControl: UntypedFormControl = new UntypedFormControl();

  readOnly = false;

  requestFocus = false;

  pendingGeolocationSubscription: Subscription = new Subscription();
  isPendingGeolocation: boolean = false;
  buscarLojasPorProximidade: BuscarLojasPorProximidadeConfig = {
    raioMetros: 0,
    autoSelecionarLojaMaisProxima: false,
  };

  longitude: number = 0;
  latitude: number = 0;

  isLoading: boolean = true;

  constructor(
    private router: Router,
    private appFlowService: AppFlowService,
    private sessionStorage: SessionStorageService,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    private geolocationService: GeolocationService,
    fb: UntypedFormBuilder,
    private canalService: CanalService
  ) {
    const envConfig: EnvConfig = sessionStorage.getSessionEntry(
      STORAGE_KEYS.ENV_CONFIG
    );
    this.messageTitle = envConfig["message.landing.title"] || "";
    if (envConfig.buscarLojasPorProximidade)
      this.buscarLojasPorProximidade = envConfig.buscarLojasPorProximidade;

    //Se tiver loja na URL, avanca direto para a proxima pagina.
    this.origemComercialId = envConfig.origemComercialId || '';

    //Caso tenha loja na URL, buscar a configuracao de consulta externa
    if(this.origemComercialId) {
      this.isLoading = false;
      this.canalService.get(this.buscarLojasPorProximidade.raioMetros, this.latitude, this.longitude).then(
        politicaResponse => {
          if(!politicaResponse) return;
          envConfig.consultaExternaConfig = { tipo: politicaResponse.consultaExterna, ...envConfig.consultaExternaConfig};
          this.sessionStorage.saveEnvConfig(envConfig);
        }
      );
    }
  }

  ngOnDestroy(): void {
    this.pendingGeolocationSubscription.unsubscribe();
  }

  async startForm(): Promise<void> {
    const envConfig: EnvConfig = this.sessionStorage.getEnvConfig();

    if (this.isPendingGeolocation) {
      this.handleGeoLocationError();
      return;
    }

    if (this.currentFormControl.value) {
      let envConfig = this.sessionStorage.getEnvConfig();
      envConfig.origemComercialId = this.currentFormControl.value;
      this.sessionStorage.saveEnvConfig(envConfig);
    }

    if (
      envConfig.consultaExternaConfig &&
      envConfig.consultaExternaConfig.tipo
    ) {
      await this.router.navigate(["/reanalise"]);

      return;
    }

    await this.router.navigate(["/iniciar"]).catch((e) => {
      let message = "Serviço indisponível no momento.";
      if (e.status < 500) {
        message = e.error.message;
      }
      this.dialog.open(DialogComponent, {
        width: "250px",
        data: { title: "Oooops!", message: message },
      });
    });
  }

  isValid(): boolean {
    if (!this.origemComercialId) {
      return this.currentFormControl.status === "VALID";
    }
    return true;
  }

  ngOnInit(): void {
    this.appFlowService.clearAppState();
  }

  ngAfterViewInit(): void {
    this.pendingGeolocationSubscription =
      this.geolocationService.pendingGeolocation.subscribe(
        (pendingGeolocation) => {
          this.isPendingGeolocation = pendingGeolocation;
        }
      );

      if(this.buscarLojasPorProximidade.raioMetros > 0) {
        navigator.geolocation.watchPosition((pos) => {
          this.latitude = pos.coords.latitude;
          this.longitude = pos.coords.longitude;
          this.handleInit();

        }, (err) => {this.isLoading = false; console.log(err); this.handleGeoLocationError();},
         {enableHighAccuracy: true, maximumAge: 0});
        return;
      }

      this.handleInit();
  }

  handleGeoLocationError(){
    const envConfig: EnvConfig = this.sessionStorage.getEnvConfig();
    const defaultErrorMessage = 'Não foi possível obter sua localização. Verifique as permissões do navegador e tente novamente.';
    let geolocationErrorMessage;

    if (browserUtils.isAndroid()) {
      geolocationErrorMessage = envConfig["menssagem.geolocalizacao.android"] ?? defaultErrorMessage;
    } else if (browserUtils.isApple()) {
      geolocationErrorMessage = envConfig["menssagem.geolocalizacao.ios"] ?? defaultErrorMessage;
    } else {
      geolocationErrorMessage = envConfig["menssagem.geolocalizacao.desktop"] ?? defaultErrorMessage;
    }

    this.dialog.open(DialogHtmlComponent, {
      width: "250px",
      data: { title: "Oooops!", message: geolocationErrorMessage },
    });
  }

  buildStoreSelectOptions(politicaResponse: PoliticaResponse): Opcoe[]{
    const storeOptions: Opcoe[] = politicaResponse.origensComerciais?.map(
            (origemComercial: Canal) => {
              return <Opcoe>{
                tipo: Tipo.Estatico,
                condicao: null,
                titulo: origemComercial.nome,
                valor: origemComercial.id.toString(),
                distanciaEmMetros: origemComercial.distanciaEmMetros,
              };
            }
          );

    if(this.buscarLojasPorProximidade.raioMetros > 0) {
      if (this.buscarLojasPorProximidade.idLojaDefault && (!storeOptions || storeOptions.length == 0)) {
            return Array.of(<Opcoe>{
              tipo: Tipo.Estatico,
              condicao: null,
              titulo: "Loja Default",
              valor: this.buscarLojasPorProximidade.idLojaDefault,
            });
          }

      if(this.buscarLojasPorProximidade.desabilitarMultiplasOpcoes) return Array.of(storeOptions[0]);
    }

    return storeOptions;
  }

  handleInit(){
     if (!this.origemComercialId) {
      if (this.requestFocus) {
        setTimeout(() => {
          this.ngSelect.focus();
        });
      }

      this.canalService
        .get(this.buscarLojasPorProximidade.raioMetros, this.latitude, this.longitude)
        .then((politicaResponse) => {
          if (!politicaResponse) return;

         this.options = this.buildStoreSelectOptions(politicaResponse);

          let envConfig = this.sessionStorage.getEnvConfig();
          envConfig.consultaExternaConfig = {
            tipo: politicaResponse.consultaExterna,
            ...envConfig.consultaExternaConfig,
          };
          this.sessionStorage.saveEnvConfig(envConfig);

          if (
            this.options &&
            this.options.length > 0 &&
            this.buscarLojasPorProximidade.autoSelecionarLojaMaisProxima
          ) {

            this.origemComercialId = this.options[0].valor;
            this.currentFormControl.setValue(this.origemComercialId);
          }
        })
        .finally(() => (this.isLoading = false));
    }
  }
}
